import React, { forwardRef } from 'react';
import { useSelector } from 'react-redux';

import { selectWorkflowsV2Enabled } from '../App/selectors';
import { ActionsTakeControl } from './ActionsTakeControl';
import { WorkflowsTakeControl } from './WorkflowsTakeControl';

export interface TakeControlProps {
  /** Explicit onExited function with context of modal button ref */
  onExited: () => void;
}

/**
 * Switch between ActionsTakeControl and WorkflowsTakeControl based on a flag.
 */
export const TakeControl = forwardRef<HTMLButtonElement, TakeControlProps>(
  (props, ref) => {
    const workflowsV2Enabled = useSelector(selectWorkflowsV2Enabled);

    if (workflowsV2Enabled) {
      return <WorkflowsTakeControl {...props} ref={ref} />;
    }
    return <ActionsTakeControl {...props} ref={ref} />;
  },
);

export default TakeControl;
